import { WallpaperConfig } from '../config/wallpaper-config';

import { buildIframeSource } from '../helpers/iframe-source';

export const PreloadService = {
  // This method will be called when a creative needs to be preloaded.
  // Every wallpaper format that we support should have it's own preload options.
  load(creative) {
    switch (creative.format) {
      case WallpaperConfig.format.IMAGE:
        return this.loadImage(creative.src);

      case WallpaperConfig.format.HTML5:
        return this.loadHTML5(creative.src);

      case WallpaperConfig.format.VIDEO:
        return this.loadVideo(creative.src);

      default:
        throw new Error(`UnsupportedCreativeType ${creative.format}`);
    }
  },

  loadImage(src) {
    return new Promise((resolve, reject) => {
      const image = new Image();

      image.onload = () => resolve();
      image.onerror = (error) => reject(error);

      image.setAttribute('src', src);
    });
  },

  loadVideo(src) {
    return new Promise((resolve, reject) => {
      const video = this.getElement('video');

      video.onloadeddata = () => {
        this.cleanUpElement(video);
        resolve();
      };
      video.onerror = (error) => {
        this.cleanUpElement(video);
        reject(error);
      };

      video.setAttribute('src', src);

      // Safari fix: apparently we need to append the video element to the DOM
      // in order for the events to fire properly.
      document.body.appendChild(video);
    });
  },

  loadHTML5(src) {
    return new Promise((resolve, reject) => {
      const frame = this.getElement('iframe');

      frame.onload = () => {
        this.cleanUpElement(frame);
        resolve();
      };

      frame.onerror = (error) => {
        this.cleanUpElement(frame);
        reject(error);
      };

      frame.setAttribute('src', buildIframeSource(src));
      document.body.appendChild(frame);
    });
  },

  getElement(tagName) {
    const element = document.getElementById('element-preloader');
    if (element) document.body.removeChild(element);

    const newElement = document.createElement(tagName);
    newElement.setAttribute('id', 'element-preloader');
    newElement.setAttribute('style', 'display: none');

    return newElement;
  },

  cleanUpElement(element) {
    document.body.removeChild(element);
    element = null;
  },
};
